module.exports = __webpack_public_path__ + "media/images/real-hostel-b25370b53e1b4a4a09260cca05c5a9af.png";